import React from 'react';
import { Document, Image, Link, PDFViewer, Page, Text, View } from '@react-pdf/renderer';
import isEmpty from 'lodash/isEmpty';
import { CURRENCY_SYMBOLS } from '@gtintel/platform-constants';
import { useStores } from '@gtintel/platform-stores';
import { formatProjectReportDetails } from '../../projectUtils';
import styles from './styles';
const PreviewPDF = () => {
  const {
    adminProjectDetailStore
  } = useStores();
  const {
    projectDetail,
    projectReports
  } = adminProjectDetailStore;
  const projectReportDetails = projectReports.results[0].projectreportsdetails;
  const {
    logos,
    executiveSummaries,
    individualComments,
    chartGraphs,
    atmospherics,
    images,
    attachments
  } = formatProjectReportDetails(projectReportDetails);
  if (projectDetail && projectDetail.id && projectReports && Array.isArray(projectReports.results) && projectReports.results.length > 0) {
    const reportDetail = projectReports.results[0];
    return <PDFViewer style={styles.back}>
        <Document>
          <Page style={styles.body} size="A4">
            <Text style={styles.header} fixed>
              Project: {projectDetail?.name}
            </Text>
            <Text style={styles.title}>Project: {projectDetail?.name}</Text>
            <Text style={styles.text}>Description: </Text>
            <Text style={styles.content}>{projectDetail?.description}</Text>
            <Text style={styles.text}>
              Tags:{' '}
              <Text style={styles.content}>
                {Array.isArray(projectDetail?.tags) && !isEmpty(projectDetail.tags) ? projectDetail.tags.map((tag, index) => ` ${tag.name}${index !== projectDetail.tags.length - 1 ? ',' : '.'}`) : '-'}
              </Text>
            </Text>
            <Text style={styles.text}>
              Requested Completion Date:{' '}
              <Text style={styles.content}>
                {projectDetail?.requested_completion_date ?? '-'}
              </Text>
            </Text>

            <Text style={styles.text}>
              Price:
              <Text style={styles.content}>
                {' '}
                {`${projectDetail?.currency_display} ${CURRENCY_SYMBOLS[projectDetail?.currency_display]}`}
                {projectDetail?.final_price}
              </Text>
            </Text>
            <Text style={styles.subtitle} break>
              Report Name: {reportDetail.name}
            </Text>

            {Array.isArray(logos) && !isEmpty(logos) && <View style={styles.viewFlex}>
                {logos.map((image, index) => {
              return <Image key={index} src={image?.value} style={styles.imageLogo} />;
            })}
              </View>}

            {Array.isArray(executiveSummaries) && !isEmpty(executiveSummaries) && executiveSummaries.map((report, index) => <>
                  {index === 0 ? <Text style={styles.textReport}>Executive Summary: </Text> : null}
                  <Text style={styles.textContent}>{report?.value}</Text>
                </>)}

            {Array.isArray(individualComments) && !isEmpty(individualComments) && individualComments.map((report, index) => <>
                  <Text style={styles.textReport}>
                    {index === 0 ? 'Individual Comment: ' : ''}
                  </Text>
                  <Text style={styles.textContent}>{report?.value}</Text>
                </>)}

            {Array.isArray(atmospherics) && !isEmpty(atmospherics) && atmospherics.map((report, index) => <>
                  <Text style={styles.textReport}>
                    {index === 0 ? 'Atmospheric: ' : ''}
                  </Text>
                  <Text style={styles.textContent}>{report?.value}</Text>
                </>)}

            {Array.isArray(chartGraphs) && !isEmpty(chartGraphs) && <>
                <Text style={styles.textReport}>Charts / Graphs: </Text>
                <View style={styles.viewFlex}>
                  {chartGraphs.map((image, index) => <Image key={index} src={image?.value} style={styles.image} />)}
                </View>
              </>}

            {Array.isArray(images) && !isEmpty(images) && <>
                <Text style={styles.textReport}>Images: </Text>
                <View style={styles.viewFlex}>
                  {images.map((image, index) => <Image key={index} src={image?.value} style={styles.image} />)}
                </View>
              </>}

            {Array.isArray(attachments) && !isEmpty(attachments) && <>
                <Text style={styles.textReport}>Attachments: </Text>
                <View style={styles.viewAttachmentFlex}>
                  {attachments.map((file, index) => <Link style={styles.textAttachment} src={file?.value} key={index}>
                      {file?.value.substring(file?.value.lastIndexOf('/') + 1).split('?')[0]}
                    </Link>)}
                </View>
              </>}
            <Text style={styles.pageNumber} render={({
            pageNumber,
            totalPages
          }) => `${pageNumber} / ${totalPages}`} fixed />
          </Page>
        </Document>
      </PDFViewer>;
  }
  return <div />;
};
export default PreviewPDF;